import React, { useState, useEffect, useRef } from 'react'
import { useFormik } from 'formik'
import { Link, Redirect } from 'react-router-dom'
import * as Yup from 'yup'
import { injectIntl } from 'react-intl'
import { toAbsoluteUrl } from '../../../../_metronic/_helpers'
import './body.scss'
import { forgotPasswordAsync } from '../_redux/auth.api'
import { useDispatch } from 'react-redux'
import PhoneInput from "react-phone-input-2";

const initialValues = {
  emailId: '',
  showField: 'email',
  contactNumber: '',
}

const addBodyClass = (className) =>
  document.body.classList.add('removeHeaderFooter')
const removeBodyClass = (className) =>
  document.body.classList.remove('removeHeaderFooter')

function ForgotPassword(props) {
  const [countryCode, setCountryCode] = useState({ country: "", code: "" });

  useEffect(() => {
		// ipAsync().then(data => {
		// 	setCountryCode({ country: data.gec.toLowerCase(), code: "+" + data.country_code })
    // });
    setCountryCode({ country: 'us', code: "+" + 1 })
	}, [])

  useEffect(() => {
    // Set up
    props.className instanceof Array
      ? props.className.map(addBodyClass)
      : addBodyClass('removeHeaderFooter')

    // Clean up
    return () => {
      props.ArrayclassName instanceof Array
        ? props.className.map(removeBodyClass)
        : removeBodyClass('removeHeaderFooter')
    }
  }, [props.className])
  const { intl } = props
  const [isRequested, setIsRequested] = useState(false)
  const ForgotPasswordSchema = Yup.object().shape({
    emailId: Yup.string().trim()
      .when("showField", {
        is: "email",
        then: Yup.string()
          .email("Please enter valid email address")
          .required("Please enter email"),
      }),
  })

  const dispatch = useDispatch()
  const phoneRef = useRef();
	const emailRef = useRef();

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return 'is-invalid'
    }
    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return 'is-valid'
    }
    return ''
  }

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: (values, { resetForm, setStatus }) => {
      try {
        console.log(values)
        dispatch(forgotPasswordAsync(values))
        resetForm({ values: '' })
      } catch (error) {
        setStatus(
          intl.formatMessage(
            { id: 'AUTH.VALIDATION.NOT_FOUND' },
            { name: values.emailId },
          ),
        )
      }
    },
  })

  return (
    <>
      {isRequested && <Redirect to="/auth" />}
      {!isRequested && (
        <>
          <div className="inner_main">
            <div className="row  w-100">
              <div className="col-xl-3 d_none_1199"></div>
              <div className="col-xl-6">
                <div className="row">
                  <div className="col-md-12 text-center mt-15 mb-10">
                    <img
                      alt="Logo"
                      className="max-h-70px mb-5"
                      src={toAbsoluteUrl('/media/logos/auth_logo.png')}
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <img
                      alt=""
                      className="mb-0 mt-4"
                      src={toAbsoluteUrl('/media/others/frgtbg.png')}
                    />
                  </div>
                  <div className="col-md-12">
                    <div className="wt_box">
                      <div
                        className="login-form login-forgot"
                        style={{ display: 'block' }}
                      >
                        <div className="text-center mb-10 mb-lg-10">
                          <h3 className="fn_s_32 color_blk f-w-500 mt-0">
                            Forgot Password?
                          </h3>
                          <p className="opacity60 fn_s_16 color_blk f-w-400">
                            Just enter the email or contact number you registered with and we will
                            send you a link to reset your password.
                          </p>
                        </div>
                        <form
                          onSubmit={formik.handleSubmit}
                          className="form def_form"
                        >
                          {formik.status && (
                            <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                              <div className="alert-text font-weight-bold">
                                {formik.status}
                              </div>
                            </div>
                          )}
                          <div className="d-flex justify-content-between">
                            <label className="form-label">
                              {formik.values.showField === 'email'
                                ? 'Email'
                                : 'Phone'}
                            </label>
                            <label
                              className="form-label dynamic_email_phone_label"
                              onClick={() =>
                                formik.setFieldValue(
                                  'showField',
                                  formik.values.showField === 'email'
                                    ? 'phone'
                                    : 'email',
                                )
                              }
                            >
                              Use{' '}
                              {formik.values.showField === 'email'
                                ? 'Phone'
                                : 'Email'}
                            </label>
                          </div>
                          <div className="form-group">
                            {formik.values.showField === 'email' && (
                              <input
                                placeholder="Email"
                                type="text"
                                className={`form-control ${getInputClasses(
                                  'emailId',
                                )} password-valid`}
                                name="emailId"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.emailId}
                                ref={emailRef}
                              />
                            )}
                            {formik.values.showField === 'phone' && (
                              <PhoneInput
                                inputProps={{
                                  name: 'contactNumber',
                                }}
                                countryCodeEditable={false}
                                placeholder="Phone"
                                country={countryCode.country}
                                value={formik.values.contactNumber}
                                inputClass="dynamic_phoneInput"
                                buttonClass="dynamic_countryDrop"
                                onChange={(phone, data, event) => {
                                  // formik.handleChange(event)
                                  formik.setFieldValue('contactNumber', phone)
                                }}
                                ref={phoneRef}
                              />
                            )}
                            {formik.values.showField === 'email' &&
                            formik.touched.emailId &&
                            formik.errors.emailId ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {formik.errors.emailId}
                                </div>
                              </div>
                            ) : null}

                            {formik.values.showField === 'phone' &&
                            formik.touched.contactNumber &&
                            formik.errors.contactNumber ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {formik.errors.contactNumber}
                                </div>
                              </div>
                            ) : null}
                          </div>
                          <div className="form-group mb-0 mt-5">
                            <div className="row">
                              <div className="col-md-12 text-center mb-5">
                                <button
                                  type="submit"
                                  className="btn btn-def defwtarw"
                                  to="/instructions-sent"
                                >
                                  <span>Continue</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 text-center mt-10 bottom_links">
                    <Link
                      to="/login"
                      className="bckbtn fn_s_14 color_blk f-w-500 opacity50 uppercase"
                    >
                      Back
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default injectIntl(ForgotPassword)
